import _defineProperty from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _asyncToGenerator from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _regeneratorRuntime from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { useEffect, useState } from 'react';
import { JoveAnimatedLoadingView } from '@jove-frontend/mui';
import { Box } from '@mui/material';
import { apiGetTripartiteCooperationInfoBySlug } from 'libs/uikit/src/api/combineApi';
import { apiGetOrganization } from 'libs/uikit/src/api/organizationApi';
import { PartnerType } from '../../../shared/generated';
import LoginFormPanel from './components/LoginFormPanel';
import LoginHeader from './components/LoginHeader';
import LoginIntroPanel from './components/LoginIntroPanel';
import { getDefaultPartnerLoginIntroInfo, getDefaultPortalLoginIntroInfo, resolvePortalLoginConfig, resolvePortalLoginIntroInfo } from './config';
import { PortalLoginSourceEnum, PortalLoginSystemSourceEnum } from './types';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export * from './types';
export { JOVE_FOOTER_INFO, JOVE_LOGO_URL, JOVE_PORTAL_BRAND, resolvePortalLoginConfig } from './config';
export var PortalLoginView = function PortalLoginView(props) {
  var onSuccess = props.onSuccess,
      onRegister = props.onRegister,
      onGoogleLogin = props.onGoogleLogin,
      onBack = props.onBack,
      _props$loginSource = props.loginSource,
      loginSource = _props$loginSource === void 0 ? PortalLoginSourceEnum.Jove : _props$loginSource,
      _props$systemSource = props.systemSource,
      systemSource = _props$systemSource === void 0 ? PortalLoginSystemSourceEnum.Cms : _props$systemSource,
      slug = props.slug,
      email = props.email,
      handleSource = props.handleSource,
      token = props.token;

  var _useState = useState(null),
      brandInfo = _useState[0],
      setBrandInfo = _useState[1];

  var _useState2 = useState(false),
      portalTwoFactorAuthenticationEnabled = _useState2[0],
      setPortalTwoFactorAuthenticationEnabled = _useState2[1];

  var isBrokerLogin = loginSource === PortalLoginSourceEnum.Broker;
  var isCmsOrgLogin = systemSource === PortalLoginSystemSourceEnum.Cms && loginSource === PortalLoginSourceEnum.Org;

  var _useState3 = useState(isBrokerLogin || isCmsOrgLogin),
      brandLoading = _useState3[0],
      setBrandLoading = _useState3[1];
  /**
   * requests
   */


  var requestBrokerDetailsInfo = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _yield$apiGetTriparti, _yield$apiGetTriparti2, res, _res$payload, _res$payload$portal_s, _res$payload2, name, logo, type, defaultIntroInfo;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setBrandLoading(true);
              _context.next = 3;
              return apiGetTripartiteCooperationInfoBySlug({
                slug: slug
              });

            case 3:
              _yield$apiGetTriparti = _context.sent;
              _yield$apiGetTriparti2 = _slicedToArray(_yield$apiGetTriparti, 1);
              res = _yield$apiGetTriparti2[0];
              setBrandLoading(false);

              if (res) {
                name = res.name, logo = res.logo, type = res.type;
                setPortalTwoFactorAuthenticationEnabled(!!(res !== null && res !== void 0 && (_res$payload = res.payload) !== null && _res$payload !== void 0 && (_res$payload$portal_s = _res$payload.portal_settings) !== null && _res$payload$portal_s !== void 0 && _res$payload$portal_s.enable_two_factor_authentication));
                defaultIntroInfo = type === PartnerType.GENERAL ? getDefaultPartnerLoginIntroInfo() : getDefaultPortalLoginIntroInfo();
                setBrandInfo({
                  name: name,
                  logoUrl: logo === null || logo === void 0 ? void 0 : logo.url,
                  loginIntroInfo: resolvePortalLoginIntroInfo(res === null || res === void 0 ? void 0 : (_res$payload2 = res.payload) === null || _res$payload2 === void 0 ? void 0 : _res$payload2.sub_broker_portal_settings, defaultIntroInfo)
                });
              }

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function requestBrokerDetailsInfo() {
      return _ref.apply(this, arguments);
    };
  }();

  var requestOrganizationDetailsInfo = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var _yield$apiGetOrganiza, _yield$apiGetOrganiza2, organization, _organization$logo;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (slug) {
                _context2.next = 3;
                break;
              }

              setBrandLoading(false);
              return _context2.abrupt("return");

            case 3:
              setBrandLoading(true);
              _context2.next = 6;
              return apiGetOrganization(slug);

            case 6:
              _yield$apiGetOrganiza = _context2.sent;
              _yield$apiGetOrganiza2 = _slicedToArray(_yield$apiGetOrganiza, 1);
              organization = _yield$apiGetOrganiza2[0];
              setBrandLoading(false);

              if (organization) {
                setBrandInfo({
                  name: organization.name,
                  logoUrl: ((_organization$logo = organization.logo) === null || _organization$logo === void 0 ? void 0 : _organization$logo.url) || ''
                });
              }

            case 11:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function requestOrganizationDetailsInfo() {
      return _ref2.apply(this, arguments);
    };
  }();
  /**
   * effects
   */


  useEffect(function () {
    if (isBrokerLogin) {
      requestBrokerDetailsInfo();
      return;
    }

    if (isCmsOrgLogin) {
      requestOrganizationDetailsInfo();
    }
  }, []);
  var config = resolvePortalLoginConfig(_objectSpread(_objectSpread({}, props), {}, {
    loginSource: loginSource
  }));
  /**
   * methods
   */

  var loginSuccessAction = function loginSuccessAction(data) {
    onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess(data);
  };

  var registerSuccessAction = function registerSuccessAction(payload) {
    onRegister === null || onRegister === void 0 ? void 0 : onRegister(payload);
  };

  var googleLoginAction = function googleLoginAction() {
    onGoogleLogin === null || onGoogleLogin === void 0 ? void 0 : onGoogleLogin();
  };

  var backAction = function backAction() {
    onBack === null || onBack === void 0 ? void 0 : onBack();
  };

  if (brandLoading) {
    return /*#__PURE__*/_jsx(JoveAnimatedLoadingView, {});
  }

  return /*#__PURE__*/_jsxs(Box, {
    className: "flex min-h-screen w-full flex-col bg-white",
    children: [/*#__PURE__*/_jsx(LoginHeader, {
      brandInfo: brandInfo,
      loginSource: loginSource
    }), /*#__PURE__*/_jsx(Box, {
      component: "main",
      className: "flex w-full flex-1 flex-col",
      children: /*#__PURE__*/_jsxs(Box, {
        className: "flex w-full flex-1 flex-col md:flex-row",
        children: [/*#__PURE__*/_jsx(LoginFormPanel, {
          brandInfo: brandInfo,
          onSuccess: loginSuccessAction,
          onRegister: registerSuccessAction,
          onGoogleLogin: googleLoginAction,
          onBack: onBack ? backAction : undefined,
          loginSource: loginSource,
          slug: slug,
          email: email,
          handleSource: handleSource,
          token: token,
          twoFactorAuthenticationEnabled: !!props.twoFactorAuthenticationEnabled && portalTwoFactorAuthenticationEnabled
        }), /*#__PURE__*/_jsx(LoginIntroPanel, {
          introInfo: brandInfo === null || brandInfo === void 0 ? void 0 : brandInfo.loginIntroInfo,
          loginSource: loginSource,
          systemSource: systemSource
        })]
      })
    })]
  });
};
export default PortalLoginView;